import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './SophisticatedTooltipLink.scss';
const SophisticatedTooltipLink = (_param)=>{
    var { className, children } = _param, rest = _object_without_properties(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        className: c(s['root'], className)
    }, rest), children);
};
SophisticatedTooltipLink.displayName = 'SophisticatedTooltipLink';
export default SophisticatedTooltipLink;
